import { Button, Flex, Modal, Tag, Typography } from "antd"
import { TemplateVideo } from "~/components/TemplateVideo"
import type { VideoTemplate } from "~/common/videoTemplate"
import styles from "./PreviewModal.css"

export const PreviewModal = ({
  card,
  open,
  onClose,
}: {
  card: VideoTemplate
  open: boolean
  onClose: () => void
}) => (
  <Modal
    centered
    className={styles.previewModal}
    footer={null}
    open={open}
    width={980}
    onCancel={onClose}
    destroyOnHidden
  >
    <Flex className={styles.previewLayout}>
      <Flex
        className={styles.previewVideoPane}
        align="center"
        justify="center"
      >
        <TemplateVideo card={card} />
      </Flex>
      <Flex
        className={styles.previewContentPane}
        vertical
        gap={24}
      >
        <Typography.Title level={4}>{card.title}</Typography.Title>
        {card.keywords.length > 0 ? (
          <Flex
            vertical
            gap={8}
          >
            <Flex
              gap={8}
              wrap
            >
              {card.keywords.map((keyword) => (
                <Tag key={keyword}>#{keyword}</Tag>
              ))}
            </Flex>
          </Flex>
        ) : null}
        <Flex
          className={styles.previewActions}
          vertical
          gap={16}
        >
          <Typography.Text type="secondary">
            {card.sameStyleUnavailableReason ||
              "你的需求我们已收到，我们会尽快开放该视频模板做同款~"}
          </Typography.Text>
          <Button
            type="primary"
            disabled
          >
            暂不支持制作同款
          </Button>
        </Flex>
      </Flex>
    </Flex>
  </Modal>
)
